<template>
  
    <div class="map" style="margin-right: -3px"></div>
  
	


</template>

<script>
  
  export default {

		name: "g-map",

    data() {
      return {
        map: null,
        markersArray: [],
        circlesArray: []
      }
    },

    props: {
      radius: {
        type: Number,
        default() {
          return 10;
        }
			},

			zoom: {
				type: Number,
				default() {
					return 10;
				}
			},

      center: {
        type: Object,
        default() {
          return null;
        }
      },

      markers: {
        type: Array,
        default() {
          return [];
        }
      }
    },

    beforeDestroy() {
      this.map = null;
    },

		async mounted() {
			let vm = this;
			
			try {
        const geocoder = new google.maps.Geocoder();

				const options = {
          disableDefaultUI: true
				}

				const map = new google.maps.Map(vm.$el, options);
        vm.map = map;
        				
        vm.handleMapClick();

        map.setCenter(new google.maps.LatLng(parseFloat(vm.center.lat), parseFloat(vm.center.lon)));
				map.setZoom(vm.zoom);
				map.setMapTypeId('roadmap');
        

        if (vm.markers.length) {
          setTimeout(function () {
            vm.placeExistingMarkers();
          }, 500);

        }
        
      } catch (error) {
        console.error(error);
      }


    },

    methods: {
      handleMapClick() {
        let vm = this;
        google.maps.event.addListener(this.map, 'click', function (event) {
          vm.$emit("mapClicked", event);
          
        });
      },

      
			placeExistingMarkers() {

				_.each(this.markers, marker => {
					var contentString = '<div id="content">' +
						'<div id="siteNotice">' + '</div>' +
						'<div id="bodyContent">' + marker.html + '</div>' +
						'</div>';

          var infowindow = new google.maps.InfoWindow({
            content: contentString,
            maxWidth: 300
					});

          var newmarker = new google.maps.Marker({
            position: new google.maps.LatLng(parseFloat(marker.lat), parseFloat(marker.lon)),
            map: this.map,
            title: marker.title
					});

          this.markersArray.push(newmarker);

					let vm = this;
          newmarker.addListener('click', function () {
						infowindow.open(this.map, newmarker);
            vm.$emit("mapClicked", marker);
          });

				});
                
        
            
        
        

        
      },

      




    },

    watch: {
      
			center(val) {
				this.map.setCenter(new google.maps.LatLng(parseFloat(this.center.lat), parseFloat(this.center.lon)));
			},

			zoom(val) {
				this.map.setZoom(this.zoom);
			}
      
    }
  }
</script>

<style scoped>
	.map {
		width: 100%;
		height: 500px;
    /*height: 100vh;*/
    
    
	}

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) {  
    .map {
      height: 300px;
    }
  }
 
  /* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
  @media (min-width: 768px) {  
 
  }
 
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) { 
    .map {
      height: 600px;
    }
  }
 
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {  
    
  }
</style>
